var React = require('react');

function Next (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(0 51) rotate(-90)","fill":"#fff","strokeLinecap":"round","strokeLinejoin":"bevel"},[React.createElement("path",{"d":"M 49.35227966308594 48 L 1.647719383239746 48 L 25.5 2.166205883026123 L 49.35227966308594 48 Z","stroke":"black","key":0}),React.createElement("path",{"d":"M 25.5 4.332412719726562 L 3.295440673828125 47 L 47.70455932617188 47 L 25.5 4.332412719726562 M 25.5 0 L 51 49 L 0 49 L 25.5 0 Z","stroke":"black","key":1})]));
}

Next.defaultProps = {"width":"49","height":"51","viewBox":"0 0 49 51"};

module.exports = Next;

Next.default = Next;
